import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display"];
  static values = {
    // Seconds left at render time, computed server-side (TestResult#time_remaining).
    remainingSeconds: Number,
    testResultId: Number
  };

  connect() {
    // Count down from the server-provided remaining duration, anchored to a
    // deadline derived from the *device* clock at page load (now + remaining).
    // Both this anchor and every tick read Date.now(), so the device's absolute
    // clock cancels out and only elapsed wall-clock matters — making the timer
    // immune to clock skew. Comparing an absolute server `finish_till` against
    // Date.now() (the previous approach) made a fast device clock hit 00:00
    // early and bounce the learner to the results page mid-exam, even though the
    // server still considered the test live.
    this.deadlineAt = Date.now() + this.remainingSecondsValue * 1000;
    this.updateTimer();
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateTimer() {
    const remaining = Math.round((this.deadlineAt - Date.now()) / 1000);

    if (remaining <= 0) {
      this.displayTarget.textContent = "00:00";
      this.handleTimeout();
      return;
    }

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    this.displayTarget.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  handleTimeout() {
    clearInterval(this.intervalId);

    // Redirect to test results page
    const resultsUrl = `/test_results/${this.testResultIdValue}`;
    window.location.href = resultsUrl;
  }
}
